/**
 * Period constants for target tracking
 */

export const QUARTERS = ["Q1", "Q2", "Q3", "Q4"];

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

/**
 * Get category-specific styling
 * @param {string} category - Disclosure category
 * @returns {string} Tailwind classes for badge styling
 */
export const getCategoryTone = (category) => {
  switch (category) {
    case "Environment":
      return "bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-200";
    case "Social":
      return "bg-blue-100 text-blue-700 dark:bg-blue-500/15 dark:text-blue-200";
    case "Governance":
      return "bg-purple-100 text-purple-700 dark:bg-purple-500/15 dark:text-purple-200";
    default:
      return "bg-muted text-muted-foreground";
  }
};
